import { InlineIcon } from '@iconify/react';
import { ActionIcon, ActionIconProps, Tooltip } from '@mantine/core';
import React, { ComponentProps } from 'react';

export interface IconButtonProps extends ActionIconProps {
  tooltip?: React.ReactNode;
  icon: ComponentProps<typeof InlineIcon>['icon'];
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const IconButton = React.forwardRef<any, IconButtonProps>(
  ({ tooltip, icon, ...props }: IconButtonProps, ref) => {
    const content = (
      <ActionIcon
        color="teal"
        radius="xl"
        variant="light"
        size={28}
        {...props}
        ref={ref}>
        <InlineIcon icon={icon} height={20} />
      </ActionIcon>
    );

    return tooltip ? (
      <Tooltip label={tooltip} withArrow withinPortal zIndex={500}>
        {content}
      </Tooltip>
    ) : (
      content
    );
  }
);
